import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

@Injectable()
export class KeyConfigService {
  private authUrl: string = environment.INVOICE_URL+'main/';

  constructor(private http: HttpClient) {}

  // A method to fetch configuration data (returns an Observable)

 loadMetadata(): Promise<any> {
     return this.http.get(this.authUrl + 'getMetadata')
       .toPromise()
       .then(response => {
        localStorage.setItem('bWV0YURhdGFDb25maWc=',response['DATA']);
         
       })
       .catch(error => {
         console.error('Failed to load metadata', error.message || error);
         return Promise.resolve();
       });
   }

}